import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { ApiResponse } from '../types/conferences';

export const getConferences = withLogger(async () => {
  const { data } = await authServiceAxiosClient.get<ApiResponse>(
    '/bigmarker/conferences',
  );

  return data;
});
